import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SecureIcon } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { UserService } from '../../services/user/user.service';
import { AppMode, AppModeService } from 'src/app/system/utility/app-mode.service';

@Component({
    selector: 'app-secure-icons',
    templateUrl: './secure-icons.component.html',
    styleUrls: ['./secure-icons.component.less'],
    standalone: false
})
export class SecureIconsComponent implements OnInit {
  AppMode = AppMode;
  secureIcon: SecureIcon[] = [];
  databaseVersion!: string;
  skin!: number;
  loggedIn : BehaviorSubject<boolean>;

  constructor(private srvES : ExternalSettingsService,
    protected srvAppMode: AppModeService,
    private srvUser : UserService) {
      this.loggedIn = this.srvUser.isLoggedIn$;
  }
  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((value) => {
      this.secureIcon = value.web.viewImages.secureicon;
      this.databaseVersion = value.databaseVersion;
      this.skin = value.globalVariables.customerWebSkinType;
    })
  }
}
